import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { CommandName } from 'utils/commands';
import { pubSub } from 'utils/pubSub';

import { TopbarButton } from '../topbarButton';

export const KeyboardCheatSheetTopbarButton = (): JSX.Element => {
  const openCheatSheet = useCallback(() => {
    ampli.commandExecuted({
      commandName: 'app:keyboardCheatSheet' satisfies CommandName,
      location: 'topbar',
    });

    pubSub.publish('command:app:keyboardCheatSheet');
  }, []);

  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="app:keyboardCheatSheet">
      Keyboard cheat sheet
    </CommandKeybindingsTooltipContent>
  );

  return (
    <TopbarButton onClick={openCheatSheet} icon="keyboard" tooltip={tooltip} />
  );
};
